document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-patient-details]').forEach(function (block) {
    const form = block.closest('form');
    if (!form) return;

    const requiredFields = block.querySelectorAll('[data-patient-required]');
    const dobField = block.querySelector('[data-patient-dob]');
    const dobHidden = block.querySelector('[data-patient-dob-hidden]');
    const errorBox = block.querySelector('[data-patient-error]');
    const ageErrorBox = block.querySelector('[data-patient-age-error]');
    const minAge = parseInt(block.getAttribute('data-min-age'), 10) || 5;

    const submitButton = form.querySelector('button[type="submit"], [name="add"]');

    function formatDateToUK(value) {
      if (!value) return '';
      const parts = value.split('-');
      if (parts.length !== 3) return '';
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function calculateAge(value) {
      if (!value) return null;

      const dob = new Date(value + 'T00:00:00');
      if (isNaN(dob.getTime())) return null;

      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      return age;
    }

    function syncDob() {
      if (dobField && dobHidden) {
        dobHidden.value = formatDateToUK(dobField.value);
      }
    }

    function validate(showErrors) {
      let allFilled = true;

      requiredFields.forEach(function (field) {
        const wrapper = field.closest('.patient-details__field');
        const filled = field.value && field.value.trim() !== '';

        if (!filled) allFilled = false;

        if (showErrors && wrapper) {
          wrapper.classList.toggle('patient-details__field--invalid', !filled);
        }
      });

      const age = calculateAge(dobField.value);
      const ageValid = age !== null && age >= minAge;

      syncDob();

      const valid = allFilled && ageValid;

      if (errorBox) {
        errorBox.hidden = allFilled || !showErrors;
      }

      if (ageErrorBox) {
        ageErrorBox.hidden = !allFilled || ageValid;
      }

      if (submitButton) {
        submitButton.disabled = !valid;
        submitButton.style.opacity = valid ? '1' : '0.6';
        submitButton.style.cursor = valid ? 'pointer' : 'not-allowed';
      }

      return valid;
    }

    requiredFields.forEach(function (field) {
      field.addEventListener('input', function () {
        validate(true);
      });

      field.addEventListener('change', function () {
        validate(true);
      });
    });

    form.addEventListener('submit', function (event) {
      syncDob();

      if (!validate(true)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    validate(false);
  });
});